import type { DataGetter } from '@rea-argonaut/analytics';
import { trackEvent } from '@rea-argonaut/analytics';
import { MOBILE_MAX } from '@property.com.au/ui-kit';
import { followPropertyModalPageSource } from '../../../components/PropertyRelationship/FollowPropertyModal/FollowPropertyModalPageSource';
import { updatePropertyRelationshipModalPageSource } from '../../../components/PropertyRelationship/UpdatePropertyRelationshipModal/UpdatePropertyRelationshipModalPageSource';

interface PropertyRelationshipModalImpressionTrackingEventData {
  event_name: 'pca_modal_impression';
  user_action: 'opened' | 'save';
  modal_name:
    | typeof followPropertyModalPageSource
    | typeof updatePropertyRelationshipModalPageSource;
  screen_name: 'property_page';
  modal_is_fullscreen: boolean;
  variant?: string | null;
  in_page_source: string | null;
}

export const useTrackPropertyRelationshipModal = () => {
  return (
    eventData: Readonly<
      Omit<
        PropertyRelationshipModalImpressionTrackingEventData,
        'event_name' | 'modal_is_fullscreen'
      >
    >,
  ) => {
    const eventGetter: DataGetter = () => ({
      schema: 'iglu:au.com.property/pca_modal_impression/jsonschema/1-0-0',
      data: {
        ...eventData,
        event_name: 'pca_modal_impression',
        modal_is_fullscreen: window ? window.innerWidth <= MOBILE_MAX + 1 : false,
      } satisfies PropertyRelationshipModalImpressionTrackingEventData,
    });
    trackEvent(eventGetter);
  };
};
